import { useState, useEffect } from 'react';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../firebase/config';

// The current auth session: the signed-in user plus their resolved custom
// claims. `hasMember` mirrors the backend's requireMember gate (admin implies
// membership), so it drives which members-only surfaces are shown, and `isAdmin`
// gates the admin console. The legacy `read` claim is still honored until the
// claim migration completes. onIdTokenChanged fires on sign-in and whenever the
// ID token refreshes, so claim changes propagate after a refresh.
export default function useSession() {
  const [state, setState] = useState({
    loading: true,
    user: null,
    isAdmin: false,
    hasMember: false,
  });

  useEffect(() => {
    const unsub = onIdTokenChanged(auth, async (user) => {
      if (!user) {
        setState({ loading: false, user: null, isAdmin: false, hasMember: false });
        return;
      }
      try {
        const { claims } = await user.getIdTokenResult();
        const isAdmin = claims.admin === true;
        const hasMember = isAdmin || claims.member === true || claims.read === true;
        setState({ loading: false, user, isAdmin, hasMember });
      } catch (_) {
        setState({ loading: false, user, isAdmin: false, hasMember: false });
      }
    });
    return unsub;
  }, []);

  return state;
}
